import type { PluginWebManifest } from '@reflex/plugin-api/web';

const DEMOS_BASE_PATH = '/docs/demos';
const DEMOS_INDEX_LABEL = 'Demos';
const DEMOS_ICON = 'PlayCircle';

/**
 * Web manifest for the guided-demos plugin. Lives in its own module so the
 * plugin definition (`src/index.ts`) and the web registration
 * (`src/web/register.ts`) can both import it without dragging server modules
 * into the browser bundle. Mirrors the `plugin-docs` pattern.
 *
 * Demos now render inside the docs shell at `/docs/demos`. The canonical URL
 * is `/docs/demos` (not `/demos`), and old `/demos` URLs redirect there.
 * Anonymous visitors can access demos without authentication.
 */
export const guidedDemosWeb: PluginWebManifest = {
  // Routes are handled directly in App.tsx inside DocsLayout. This keeps the
  // demos route tree integrated with docs (sidebar, breadcrumbs).
  routes: [],
  // Demos remain discoverable through the docs sidebar and command palette, but
  // should not add a second entry to the authenticated app nav.
  navItems: [],
  commands: [
    {
      to: DEMOS_BASE_PATH,
      label: DEMOS_INDEX_LABEL,
      icon: DEMOS_ICON,
      group: 'navigation',
      rootLevel: true,
    },
  ],
};

export const DEMOS_BASE_PATH_VALUE = DEMOS_BASE_PATH;
